/**
 * lockScroll — stop the page behind a drawer/sheet from scrolling.
 * Returns an unlock function. Nested locks are counted.
 * The lock goes on <html>: index.css gives <html> `overflow-x: clip`, so an
 * overflow on <body> would not reach the viewport.
 */
let locks = 0;
let saved = '';

export function lockScroll() {
  if (typeof document === 'undefined') return () => {};
  const root = document.documentElement;
  if (locks === 0) {
    saved = root.style.overflow;
    root.style.overflow = 'hidden';
  }
  locks += 1;
  let released = false;
  return () => {
    if (released) return;
    released = true;
    locks = Math.max(0, locks - 1);
    if (locks === 0) root.style.overflow = saved;
  };
}

export default lockScroll;
